export default "__VITE_ASSET__aNrcwvmY__"